
<div class="mt-1">
    <div class="row" style="border-bottom: 1px solid #d0d0ce;margin-left: 10px;margin-right:10px">
      <div class="col-md-3" *ngIf="!iseditTransaction">
        <h1>New Request</h1>
      </div>
      <div class="col-md-3" *ngIf="iseditTransaction">
        <h1>Edit Request</h1>
      </div>
  </div>
  
  </div>
  
    <div id="accordion" class="accordion">
    
        <div class="card"    style="border-bottom: 1px solid lightgrey;">
            <div id="headingOne" class="card-header bg-white border-0">
                <h5 class="mb-0 font-weight-bold"><a href="#" style="text-decoration: none;font-family: OpenSans SemiBold;color:#000" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" class="d-block position-relative text-dark collapsible-link py-2">General Information</a></h5>
                <form #outwardregform="ngForm">
            <div id="collapseOne" aria-labelledby="headingOne" data-parent="#accordion" class="collapse show">
                <div id="dBox" class="card-body" style="padding:10px">
                   
                 
                    <div class="item1">
                      <div class="from-group mt-1" >
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                          <strong>Request name <span class="required">*</span></strong>
                          <input  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" type="text" style = "padding-left :10px;height:30px;" class="form-control"  [(ngModel)]="RequestName"
                          name="RequestName"  id="RequestName" autocomplete="off" [ngModelOptions]="{standalone: true}" 
                          placeholder="Enter " required>  
                        
                        </div>
                    </div>
                    </div>
                    <div class="item2">
                     
                    <div class="from-group mt-1" >
                      <div class="form-group typeahead-wrap mt-1" style="width:100%">
                        <strong>Request type<span class="required">*</span></strong>
                        <ngx-select  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" [items]="RequestTypeData" id="requesttype" name="requesttype" optionValueField="transactionStatusId" optionTextField="name"
                placeholder="Select"  [(ngModel)]="RequestSelected" [noAutoComplete]=false 
                [ngModelOptions]="{standalone: true}" (select)="RequestTypeDetails.transactionStatusId"
                (ngModelChange)="OnRequestChange($event)"  required style="height: 30px;">
    </ngx-select>
                      </div>
                  </div>
                    </div>
                    <div class="item3">
                      <div class="form-group mt-1">
                        <strong>Request date <span class="required">*</span></strong>
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                          <input [disabled]="iseditTransaction ? 'true' : 'false'" type="text" class="form-control dpinputwidth" [ngModel]="dateInputData.RequestDate" 
                                 (ngModelChange)="dateInputData.RequestDate=$event; validateRequestDate($event)" autocomplete="off" name="requestDate" id="fromDate"
                                 [ngModelOptions]="{standalone: true}" style="height:30px;"
                                 [minDate]="dateInputData.FromMinDate" [maxDate]="dateInputData.maxDate"
                                 [bsConfig]="{ containerClass: 'theme-default', showWeekNumbers: false }" placeholder="MMM/DD/YYYY"
                                 placement="bottom left" #fromdate #fromDate="bsDatepicker" bsDatepicker >
                          <i class="icon-ic_calendar show-cursor" (click)="fromDate.toggle()">
                             </i>
                        </div>
                      </div>
                    
                    </div>  
                    <div class="item4">
                      <div class="form-group mt-1">
                        <strong>Request time <span class="required">*</span></strong>
                        <div class="typeahead-wrap-clock" [style.opacity]="iseditTransaction ? '0.3' : '1'">
                          <ng-template #fromtimetemplate>
                            <timepicker [disabled]="iseditTransaction ? 'true' : 'false'" [(ngModel)]="fromtimepickervalue" (click)="$event.stopPropagation();"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="fromTimePickerValueChanges($event)"
                                        (isValid)="isFromValid($event)" [minuteStep]="mstep"  ></timepicker>
                          </ng-template>
                          <input style="width: 100%;height:30px;border: 1px solid #d0d0ce;" value="fromtimevalue"  readonly #fromtime name="ftime" [(ngModel)]="fromtimevalue" >
                          <span class="icon-ic_time" style="cursor: pointer;" [popover]="fromtimetemplate" [outsideClick]="true" placement="bottom"></span>
                        </div>
                        <div *ngIf="!isValidTime" class="alert alert-danger">Please provide valid time</div>
                      
                      </div>
                   
                    </div>
                    
                    <div class="item7" *ngIf="RequestTypeName==3|| RequestTypeName==1||RequestTypeName=='Returnable'||RequestTypeName=='Internal movement'">
                      <div class="form-group mt-1" >
                        <strong>Due date <span class="required">*</span></strong>
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                          <input [disabled]="RequestTypeName === 'Returnable' && iseditTransaction ? 'ture' : 'false'" type="text" class="form-control dpinputwidth" [ngModel]="dateInputData.DueDate"
                                (ngModelChange)="dateInputData.DueDate=$event; onDueDateChanged($event); validateDueDate($event)" autocomplete="off" name="dueDate" id="fromDate"
                                 [ngModelOptions]="{standalone: true}" style="height:30px;"
                                 [minDate]="dateInputData.FromMinToDate" [maxDate]="dateInputData.maxToDate"
                                 [bsConfig]="{ containerClass: 'theme-default', showWeekNumbers: false }" placeholder="MMM/DD/YYYY"
                                 placement="bottom left" #fromdate #fromDate="bsDatepicker" bsDatepicker>
                          <i class="icon-ic_calendar show-cursor" (click)="fromDate.toggle()">
                             </i>
                        </div>
                      </div>
                   
                    </div>
                    <div class="item8" *ngIf="RequestTypeName=='3'|| RequestTypeName=='1'||RequestTypeName=='Returnable'||RequestTypeName=='Internal movement'">
                      <div class="form-group mt-1">
                        <strong>Due time <span class="required">*</span></strong>
                        <div class="typeahead-wrap-clock" [style.opacity]="iseditTransaction ? '0.3' : '1'" [style.pointer-events]="iseditTransaction ? 'none' : 'auto'">
                          <ng-template #duetimetemplate>
                            <timepicker [(ngModel)]="duetimepickervalue" (click)="$event.stopPropagation();"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="dueTimePickerValueChanges($event)"
                                        (isValid)="isFromValid($event)" [minuteStep]="mstep"  ></timepicker>
                          </ng-template>
                          <input style="width: 100%;height:30px;border: 1px solid #d0d0ce;" value="duetimevalue"  readonly #duetime name="dtime" [(ngModel)]="duetimevalue" >
                          <span class="icon-ic_time" style="cursor: pointer;" [popover]="duetimetemplate" [outsideClick]="true" placement="bottom" *ngIf="!iseditTransaction"></span>
                          <span class="icon-ic_time" style="cursor: not-allowed;" *ngIf="iseditTransaction"></span>
                        </div>
                        <div *ngIf="!isValidTime" class="alert alert-danger">Please provide valid time</div>
                      
                      </div>
                   
                    </div>
                    <div class="item9" *ngIf="RequestTypeName=='Returnable' && iseditTransaction==true">
                      <div class="form-group mt-1" >                       
                        <strong>Revised Due date</strong>
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                                 <input type="text" class="form-control dpinputwidth" [ngModel]="dateInputData.RevisedDate"
                                 (ngModelChange)="dateInputData.RevisedDate=$event; validateRevisedDueDate($event)" autocomplete="off" name="revisedDate" id="fromDate"
                                 [ngModelOptions]="{standalone: true}" style="height:30px;"
                                 [minDate]="dateInputData.FromMinToDate" [maxDate]="dateInputData.maxToDate"
                                 [bsConfig]="{ containerClass: 'theme-default', showWeekNumbers: false }" placeholder="MMM/DD/YYYY"
                                 placement="bottom left" #fromdate #fromDate="bsDatepicker" bsDatepicker>
                          <i class="icon-ic_calendar show-cursor" (click)="fromDate.toggle()">
                             </i>
                        </div>
                      </div>
                    </div>
                    <div class="item10" *ngIf="RequestTypeName=='Returnable' && iseditTransaction==true">
                      <div class="form-group mt-1">
                        <strong>Revised Due time</strong>
                        <div class="typeahead-wrap-clock" [style.opacity]="iseditTransaction ? '1' : '0.3'">
                          <ng-template #revisedduetimetemplate>
                            <timepicker [(ngModel)]="revisedduetimepickervalue" (click)="$event.stopPropagation();"
                                        [ngModelOptions]="{standalone: true}" (ngModelChange)="rdueTimePickerValueChanges($event)"
                                        (isValid)="isFromValid($event)" [minuteStep]="mstep"  ></timepicker>
                          </ng-template>
                          <input style="width: 100%;height:30px;border: 1px solid #d0d0ce;" value="revisedduetimevalue"  readonly #revisedduetime name="rtime" [(ngModel)]="revisedduetimevalue" >
                          <span class="icon-ic_time" style="cursor: pointer;" [popover]="revisedduetimetemplate" [outsideClick]="true" placement="bottom"></span>
                        </div>
                        <div *ngIf="!isValidTime" class="alert alert-danger">Please provide valid time</div>
                      
                      </div>
                   
                    </div>
                    <div class="item7">
                      <div class="from-group mt-1" >
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                          <strong>Material sent to <span class="required">*</span></strong>
                          <input  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" type="text" style = "padding-left :10px;height: 30px;" class="form-control"  [(ngModel)]="MaterialSentTo"
                          name="MaterialSentTo"  id="MaterialSentTo" autocomplete="off" [ngModelOptions]="{standalone: true}"
                          placeholder="Enter name" required>  
                        </div>
                    </div>
                    </div>
                    <div class="item8">
                    <div class="from-group mt-1" >
                      <div class="form-group typeahead-wrap mt-1" style="width:100%">
                        <strong>Practice <span class="required">*</span></strong>
                        <ngx-select  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" [items]="PracticeData" id="practice" name="practice" optionValueField="practiceId" optionTextField="name"
                placeholder="Select" (select)="PracticeDetails.PracticeId" [(ngModel)]="PracticeSelected" [noAutoComplete]=false [ngModelOptions]="{standalone: true}"
                (ngModelChange)="OnPracticeChange($event)" required>
                        </ngx-select>
                      </div>
                  </div>
                    </div> 

                     <div class="item9">
                     <div class="form-group mt-1" >
                      <strong style="margin-bottom: 11px;">City</strong>
                      <div class="mt-2">
                        <ngx-select  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" [items]="cityData" optionValueField="cityID" optionTextField="cityName" placeholder="Select"
                        (select)="selectCity()" [(ngModel)]="CitySelected" [noAutoComplete]="false"
                        (ngModelChange)="OnchangeCity($event)" [ngModelOptions]="{standalone: true}" required>
                      </ngx-select>
                    </div>
                  </div>
               
                    </div> 
                    <div class="item10">
                     
                    <div class="from-group mt-1">
                      <strong style="margin-bottom: 11px;">Office</strong>
                 
          <ngx-select  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" [items]="officeData" id="office" name="office" optionValueField="officeID" optionTextField="officeName"
          placeholder="Select" (select)="OfficeDetails.officeID" [(ngModel)]="OfficeSelected" [noAutoComplete]=false [ngModelOptions]="{standalone: true}"
          (ngModelChange)="OnOfficeChange($event)" required>
</ngx-select>

                  </div>
                  
                    </div>  
                    
                   
                    <div class="item11">
                      <div class="from-group mt-1" >
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                          <strong>Material carried by <span class="required">*</span></strong>
                          <input  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" type="text" style = "padding-left :10px;height: 30px;" class="form-control"  [(ngModel)]="MaterialCarriedBy"
                          name="MaterialCarriedBy"  id="MaterialCarriedBy" autocomplete="off" [ngModelOptions]="{standalone: true}"
                          placeholder="Enter name" required>  
                         
                        </div>
                    </div>
                     
                    </div> 

                    <div class="item12">
                      <div class="from-group mt-1" >
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                          <strong>LA approver 1 <span class="required">*</span></strong>
                          <!-- <input type="text" style = "padding-left :10px;" class="form-control"  [(ngModel)]="LaApprov1"
                          name="LaApprov1"  id="LaApprov1" autocomplete="off" [ngModelOptions]="{standalone: true}"
                          placeholder="Enter " required>   -->
                          <ngx-select  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" [items]="Appr1Data" id="apprId" name="apprName" optionValueField="appUserID" optionTextField="firstLastName"
                          placeholder="Select" (select)="OnAppr1Change($event)" [(ngModel)]="Appr1Selected" [noAutoComplete]=false [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="OnAppr1Change($event)" required style="height: 30px;">
              </ngx-select>
                        </div>
                    </div>
                    </div> 
                    <div class="item13">
                      <div class="from-group mt-1" >
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                           <strong>LA approver 2 <span class="required">*</span></strong>
                        
                          <ngx-select  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" [items]="Appr2Data" id="LaApprov2" name="apprName" optionValueField="appUserID" optionTextField="firstLastName"
                          placeholder="Select"  [(ngModel)]="Appr2Selected" [noAutoComplete]=false [ngModelOptions]="{standalone: true}" (select)="Appr2Details.appUserID"
                          (ngModelChange)="OnAppr2Change($event)" required style="height: 30px;">
              </ngx-select>
                        </div>
                    </div>
                    </div> 
                   
                     <div class="item14">
                      <div class="from-group mt-1" >
                        <div class="form-group typeahead-wrap mt-1" style="width:100%">
                          <strong>Purpose <span class="required">*</span></strong>
                          <input  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" type="text" style = "padding-left :10px;height: 30px;" class="form-control"  [(ngModel)]="Purpose"
                          name="Purpose"  id="Purpose" autocomplete="off" [ngModelOptions]="{standalone: true}"
                          placeholder="Enter purpose" required>  
                        </div>
                      </div>
                    </div> 
                    
                    <div class="item15">
                      <strong>Remarks</strong>
                      <div class="form-group">
                        <textarea  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" style="resize: none;" class="form-control" rows="4" id="Remarks" [(ngModel)]="Remarks" name="Remarks" [ngModelOptions]="{standalone: true}" ></textarea>
                       
                      </div>
                    </div>
                                     
            </div>
</div>
</form>
          </div>
    </div>
  

    <!-- Materials DropDown -->
    <!-- <div id="headingOne" class="card-header bg-white border-0">
      <h4 class="mb-0 font-weight-bold"><span style="text-decoration: none;font-family: OpenSans SemiBold;color:#000" class="d-block position-relative text-dark py-2">Materials</span></h4>
    </div> -->
    <div class="mt-1">
      <div *ngIf="attachedFiles.length > 0">
        <div class="col-md-3" style="margin-top: 10px;">
        <h3>Attached Files:</h3>
        </div>
        <ul>
          <li *ngFor="let file of attachedFiles; let i = index">
            {{ file.name }}
            <img *ngIf="!(iseditTransaction && RequestStatusName !== 'Created')" src="assets/images/delete.png" alt="Delete" width="16" height="16" (click)="deleteFile(i)"
             style="cursor: pointer;margin-left: 20px;"> 
          </li>
        </ul>
      </div>
      <div class="row" style="margin-top:30px;margin-left: 10px;margin-right:10px">
        <div class="col-md-3">
          <h3>Materials</h3>
        </div>
        <div class="col-md-9 d-flex justify-content-end">
          <!-- <div class="importMat"  disabled="true">
            <span>Import Material</span>
          </div> -->
          <div *ngIf="RequestTypeName !== 'Returnable' || RequestStatusName === 'Created'"class="addMat" (click)="addMaterial()">
            <span >Add Material</span>
          </div>
          <div *ngIf="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" class="addMat"  disabled>
            <span >Add Material</span>
          </div>
          <div class="upload-material" (click)="UploadMaterial()" [ngClass]="{'disabled': attachedFiles.length == 3 || (iseditTransaction && RequestStatusName !== 'Created')}">
            <span >Upload Material</span>
          </div>
          <app-upload-material *ngIf="showUploadMaterial" (close)="closeUploadMaterial()"  (fileData)="handleFileData($event)"></app-upload-material>
        </div>
    </div>
    
    </div>
  
    <div class="card" style="margin-top: 10px;margin-bottom: 80px;margin-left:10px;margin-right:10px;">
      <div [ngClass]="{'scrollable':this.materialList.length > 4}"> 
        <table class="demTable">
          <thead>
            <tr>
              <th>S.No.</th>
              <th width="40%">Description</th>
              <th>Required Quantity</th>
              <th width="30%">Notes</th>
              <th></th>
            </tr>
            <tr class="table-row" *ngFor="let material of materialList;let i = index">
              <td>&nbsp;<span>{{i+1}}</span></td>
              <td>
                <div class="BoxOne">
                  <input  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" type="text" [(ngModel)]="material.name"  name="matName" #matName="ngModel" id="matName" autocomplete="off" class="form-control mt-0" placeholder="Enter">
                </div>
              </td>
              <td>
                <!-- <div class="BoxOne">
                  <input type="number" [(ngModel)]="material.quantity" name="matQuan" #matQuan="ngModel" id="matQuan" autocomplete="off" class="form-control mt-0" placeholder="Enter">
                </div> -->
                <div class="BoxTwo">
                  <input  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" type="number" style="position:relative;top:3px;left:10px;" [(ngModel)]="material.quantity" name="matQuan" #matQuan="ngModel" id="matQuan" autocomplete="off" class="form-control mt-0" placeholder="Enter">
                  <div class="BoxFour">
                    <div class="UpArrow"><img src="../../../../assets/images/UpArrow.png" (click)="increase(i)" style="height: 8px;width: 10px;" class="show-cursor" [alt]=""/></div>
                    <div class="DownArrow"><img src="../../../../assets/images/DownArrow.png" (click)="decrease(i)" style="height: 8px;width: 10px;" class="show-cursor" [alt]=""/></div>
                  </div>
                </div>
              </td>
              <td>
                <div class="BoxOne">
                  <input  [disabled]="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" type="text" [(ngModel)]="material.notes" name="matNotes" #matNotes="ngModel" id="matNotes" autocomplete="off" class="form-control mt-0" placeholder="Enter">
                </div>
              </td>
              <td>
                <div *ngIf="RequestTypeName !== 'Returnable' || RequestStatusName === 'Created'" class="BoxOne">
                  <img  src="../../../../assets/images/delete.png" (click)='removeMaterial(i)' class="show-cursor" [alt]="X"/>
                </div>
                <div *ngIf="RequestTypeName === 'Returnable' && RequestStatusName !== 'Created'" class="BoxOne" disabled>
                  <img  src="../../../../assets/images/delete.png" class="show-cursor" [alt]="X"/>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <div class="card" style="margin-top: 10px;margin-bottom: 80px;margin-left: 10px;margin-right: 10px;">
      <div class="MaterialsDropdown">
        <div class="SNoBox">
          <div id="headingOne" class="card-header bg-white border-0">
            <h5 class="mb-0"><span style="text-decoration: none;font-family: OpenSans SemiBold;color:#53565A" class="d-block position-relative py-2">No.</span></h5>
          </div>
        </div>
        <div class="DescBox">
          <div id="headingOne" class="card-header bg-white border-0">
            <h5 class="mb-0"><span style="text-decoration: none;font-family: OpenSans SemiBold;color:#53565A" class="d-block position-relative py-2">Description</span></h5>
          </div>
        </div>
        <div class="QuanBox">
          <div id="headingOne" class="card-header bg-white border-0">
            <h5 class="mb-0"><span style="text-decoration: none;font-family: OpenSans SemiBold;color:#53565A" class="d-block position-relative py-2">Required Quantity</span></h5>
          </div>
        </div>
        <div class="DescBox">
          <div id="headingOne" class="card-header bg-white border-0">
            <h5 class="mb-0"><span style="text-decoration: none;font-family: OpenSans SemiBold;color:#53565A" class="d-block position-relative py-2">Notes</span></h5>
          </div>
        </div>
      
      </div>
      <hr style="margin-top: 0px;"/>
      <div class="card-body" style="padding: 0px;flex-direction: column;min-height: 0px;">
          <div class="MaterialBox" *ngFor="let material of materialList;let i = index">
            <div class="SerialBox">
                <span>{{i+1}}</span>
            </div>
              <div class="MaterialDesc">
                <div class="BoxOne">
                  <input type="text" [(ngModel)]="material.name"  name="matName" #matName="ngModel" id="matName" autocomplete="off" class="form-control mt-0" placeholder="Enter">
                  <!-- <div *ngIf="matName.invalid && (matName.dirty || matName.touched)" class="alert alert-danger">
                    <div class="mt-2" *ngIf="matName.errors.required" >
                      Material Name is required.
                    </div>
                  </div> -->
                <!-- </div>
              </div>
              <div class="MaterialQuantity">
                <div class="BoxOne">
                  <input type="number" [(ngModel)]="material.quantity" name="matQuan" #matQuan="ngModel" id="matQuan" autocomplete="off" class="form-control mt-0" placeholder="Enter">
                   <div *ngIf="matQuan.invalid && (matQuan.dirty || matQuan.touched)" class="alert alert-danger">
                    <div class="mt-2" *ngIf="matQuan.errors.required" >
                      Material Quantity is required.
                    </div>
                  </div> 
                </div>
              </div>
              <div class="MaterialDesc">
                <div class="BoxOne">
                  <input type="text" [(ngModel)]="material.notes" autocomplete="off" class="form-control mt-0" placeholder="Enter">
                   <div *ngIf="matName.invalid && (matName.dirty || matName.touched)" class="alert alert-danger">
                    <div class="mt-2" *ngIf="matName.errors.required" >
                      Material Name is required.
                    </div>
                  </div> 
                </div>
              </div>
           
              <div class="Deletebtn">
                <div class="BoxOne">
                   <button (click)='removeMaterial(i)'> X</button> -->
                  <!-- <i class="icon-ic_cloud show-cursor" (click)="fromDate.toggle()">
                  </i>  
                  <img src="../../../../assets/images/delete.png" (click)='removeMaterial(i)' class="show-cursor" [alt]="X"/>
                </div>
              </div>
          </div> 
           <div class="AddMaterialBox">
            <div class="row">
              <div class="col mx-3">
                <a style="color:#00a3e0" (click)="addMaterial()">Add Material</a>
              </div>
              <div class="col mx-1">
                <a (click)="uploadMaterial()">Import Materials</a>
              </div>
              <div class="col mx-1"></div>
              <div class="col mx-1"></div>
              <div class="col mx-1"></div>
              <div class="col mx-1"></div>
              <div class="col mx-1"></div>
              <div class="col mx-1"></div>
            </div>
          </div> 
      </div>
    </div> -->
  
  
  
    <!-- Footer -->
  <footer class="page-footer" style="border-top: 1px solid #D0D0CE;">
  <button type="button" (click)="goBack()" style="background: #53565A;color: white;"><span>Cancel</span></button>
  <button type="button" [disabled]="showButton()"  *ngIf="!iseditTransaction" style="background: #007CB0;color: white;" (click)="submit()"><span>Register</span></button>
  <button type="button" *ngIf="iseditTransaction" [disabled]="this.showButton()" style="background: #007CB0; color: white;" (click)="submit()"><span>Save</span></button>
  </footer>
 <!-- Footer -->
